"use client";

import Link from "next/link";
import {useState} from "react";
import {ChevronDown, Menu, X} from "lucide-react";

export default function HeaderMega({data}) {
    const {logo, menu = [], cta, layout = {}, background = {}} = data;
    const [mobileOpen, setMobileOpen] = useState(false);
    const [activeDropdown, setActiveDropdown] = useState(null);

    const isSticky = layout?.sticky;
    const isTransparent = layout?.transparent;
    const bgClass =
        background.type === "color"
            ? `bg-[${background.value}]`
            : isTransparent
                ? "bg-transparent"
                : "bg-white";

    return (
        <header className={`w-full z-50 ${isSticky ? "sticky top-0" : ""} ${bgClass} shadow-sm`}>
            <div className="max-w-7xl mx-auto px-4 py-4 flex justify-between items-center">
                {/* Logo */}
                <Link href="/">
                    <img src={logo?.src} alt={logo?.alt || "Logo"} className="h-8 w-auto"/>
                </Link>

                {/* Desktop Menu */}
                <nav className="hidden md:flex items-center space-x-6 relative">
                    {menu.map((item, idx) => (
                        <div key={idx} className="relative group">
                            <button
                                onClick={() => setActiveDropdown(activeDropdown === idx ? null : idx)}
                                className="flex items-center text-sm font-medium text-gray-700 hover:text-primary"
                            >
                                {item.label}
                                {item.children && <ChevronDown size={14} className="ml-1"/>}
                            </button>
                            {item.children && (
                                <div
                                    className="absolute left-0 top-full mt-2 w-64 bg-white border rounded-lg shadow-lg opacity-0 group-hover:opacity-100 group-hover:translate-y-1 transition-all duration-200 z-50 p-4">
                                    {item.children.map((sub, subIdx) => (
                                        <Link key={subIdx} href={sub.href} className="block mb-2">
                                            <div className="text-sm font-semibold text-gray-900">{sub.label}</div>
                                            {sub.description && (
                                                <div className="text-xs text-gray-500">{sub.description}</div>
                                            )}
                                        </Link>
                                    ))}
                                </div>
                            )}
                        </div>
                    ))}

                    {/* CTA */}
                    {cta && (
                        <Link
                            href={cta.href}
                            className={`ml-4 px-4 py-2 rounded ${
                                cta.style === "primary"
                                    ? "bg-primary text-white"
                                    : cta.style === "secondary"
                                        ? "bg-gray-200 text-gray-900"
                                        : "text-primary underline"
                            }`}
                        >
                            {cta.text}
                        </Link>
                    )}
                </nav>

                {/* Mobile Toggle */}
                <button onClick={() => setMobileOpen(!mobileOpen)} className="md:hidden">
                    {mobileOpen ? <X size={24}/> : <Menu size={24}/>}
                </button>
            </div>

            {/* Mobile Menu */}
            {mobileOpen && (
                <div className="md:hidden bg-white border-t">
                    <div className="flex flex-col px-4 py-2 space-y-2">
                        {menu.map((item, idx) => (
                            <div key={idx}>
                                <Link href={item.href || "#"} className="text-sm font-medium text-gray-700">
                                    {item.label}
                                </Link>
                                {item.children && (
                                    <div className="ml-4 mt-1 space-y-1">
                                        {item.children.map((sub, subIdx) => (
                                            <Link
                                                key={subIdx}
                                                href={sub.href}
                                                className="text-sm text-gray-600 hover:text-primary block"
                                            >
                                                {sub.label}
                                            </Link>
                                        ))}
                                    </div>
                                )}
                            </div>
                        ))}
                        {cta && (
                            <Link
                                href={cta.href}
                                className={`mt-2 px-4 py-2 text-center rounded ${
                                    cta.style === "primary"
                                        ? "bg-primary text-white"
                                        : cta.style === "secondary"
                                            ? "bg-gray-200 text-gray-900"
                                            : "text-primary underline"
                                }`}
                            >
                                {cta.text}
                            </Link>
                        )}
                    </div>
                </div>
            )}
        </header>
    );
}